var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoupinLogoMobileHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "youpin-logo-mobile-header",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 59.796,
    height: 48,
    viewBox: "0 0 59.796 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_4051",
    "data-name": "Ret\\xE2ngulo 4051",
    width: 59.796,
    height: 48,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19710",
    "data-name": "Grupo 19710"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19709",
    "data-name": "Grupo 19709",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19708",
    "data-name": "Grupo 19708",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20482",
    "data-name": "Caminho 20482",
    d: "M39.08.448c-2.874,4.9-4.9,8.415-6.975,12.125-1.086,1.964-2.187,3.968-3.42,6.263-.581,1.068-1.185,2.2-1.831,3.4.223,1.88.407,3.438.579,4.9q-.682,4.546-1.366,9.1c-2.51.3-4.382.546-7.421.951-.745-5.475-1.119-8.208-1.864-13.683C10.272,16.144,6.924,12.5.058,5.3.033,5.144.025,5.069,0,4.913c4.672-.737,7.016-1.078,11.7-1.731,3.711,4.281,5.533,6.435,9.127,10.775C23.35,8.846,24.642,6.3,27.276,1.226,31.981.7,34.325.448,39.039,0c.016.182.024.274.041.448",
    fill: "#5d00c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20483",
    "data-name": "Caminho 20483",
    d: "M207.542,97.181c-6.237-1.119-9.74-1.706-15.332-2.561-1.086,1.964-2.187,3.968-3.42,6.263-.415,2.767-.837,5.533-1.252,8.3q-.682,4.546-1.366,9.1-.771,5.107-1.532,10.212c3.917.589,5.872.9,9.781,1.549.614-3.686.929-5.533,1.541-9.219,2.849.473,4.265.722,7.106,1.226,9.368,1.581,15.142-2.792,16.558-9.724,1.358-6.644-2.287-13.4-12.085-15.15m1.98,13.336a4.058,4.058,0,0,1-4.986,3.412c-2.883-.522-4.324-.771-7.207-1.252.563-3.4.845-5.093,1.416-8.49,2.925.489,4.39.745,7.306,1.268a4.146,4.146,0,0,1,3.471,5.061",
    transform: "translate(-160.105 -82.047)",
    fill: "#d764ff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoupinLogoMobileHeader);
export default __webpack_public_path__ + "static/media/youpin-logo-mobile-header.9888557155aa59144f1d573966c61004.svg";
export { ForwardRef as ReactComponent };